var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatimentDroite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 448 449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4efed;}.cls-2{fill:#aa6671;}.cls-3{fill:#bcbed5;stroke-width:3px;}.cls-3,.cls-4{stroke:#fff;stroke-miterlimit:10;}.cls-4{fill:none;stroke-width:2px;}.cls-5{fill:#fcfcfc;}.cls-6{fill:#fff;}.cls-7{opacity:0.18;fill:url(#D\xE9grad\xE9_sans_nom_57);}.cls-8{fill:#304a54;opacity:0.38;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 224,
    y1: 217,
    x2: 224,
    y2: 449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ec8da",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6391b7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Finaux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batiment_droite_1",
    "data-name": "batiment droite 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 448,
    height: 449
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fen\\xEAtres_gauche",
    "data-name": "Fen\\xEAtres gauche"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32,
    width: 49,
    height: 449
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 18,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.5,
    y1: 19.5,
    x2: 56.5,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 73,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.5,
    y1: 74.5,
    x2: 56.5,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 129,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.5,
    y1: 130.5,
    x2: 56.5,
    y2: 151.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 185,
    width: 46,
    height: 22.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.5,
    y1: 186.53,
    x2: 56.5,
    y2: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 240,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.5,
    y1: 241.6,
    x2: 56.5,
    y2: 264
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 301,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55.5,
    y1: 301.6,
    x2: 55.5,
    y2: 324
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.5,
    y: 360,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55.5,
    y1: 360.6,
    x2: 55.5,
    y2: 383
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fen\\xEAtres_gauche-2",
    "data-name": "Fen\\xEAtres gauche"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384,
    width: 49,
    height: 449
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 18,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.5,
    y1: 19.5,
    x2: 408.5,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 73,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.5,
    y1: 74.5,
    x2: 408.5,
    y2: 95.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 129,
    width: 46,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.5,
    y1: 130.5,
    x2: 408.5,
    y2: 151.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 185,
    width: 46,
    height: 22.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.5,
    y1: 186.53,
    x2: 408.5,
    y2: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 240,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.5,
    y1: 241.6,
    x2: 408.5,
    y2: 264
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 301,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 407.5,
    y1: 301.6,
    x2: 407.5,
    y2: 324
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 385.5,
    y: 360,
    width: 46,
    height: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 407.5,
    y1: 360.6,
    x2: 407.5,
    y2: 383
  })), /*#__PURE__*/React.createElement("g", {
    id: "balcons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 14,
    width: 229,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "balcon_original",
    "data-name": "balcon original"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 47,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 34.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 32,
    width: 251,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 67.5,
    width: 229,
    height: 42.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 103,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 90.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 88,
    width: 251,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 123.5,
    width: 229,
    height: 44.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 161,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 148.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 146,
    width: 251,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 182.5,
    width: 229,
    height: 41.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 217,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 204.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 202,
    width: 251,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 238,
    width: 229,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 275,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 262.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 260,
    width: 251,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 296.5,
    width: 229,
    height: 44.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 334,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 321.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 319,
    width: 251,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119,
    y: 355.5,
    width: 229,
    height: 48.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 397,
    width: 251,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 107,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.86,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.72,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.58,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.44,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 151.29,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 160.15,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 169.01,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.87,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.73,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.59,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.45,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.31,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.16,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.02,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.88,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.74,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.6,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 266.46,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.32,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 284.18,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.04,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 301.89,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.75,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.61,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.47,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.33,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.19,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.05,
    y: 384.1,
    width: 2.95,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 107,
    y: 382,
    width: 251,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 217,
    width: 448,
    height: 232
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "batiment_droite_2",
    "data-name": "batiment droite 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 12,
    width: 451,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatimentDroite1);
export default __webpack_public_path__ + "static/media/batiment_droite_1.817bc6424349ac12cfc93762a85c639b.svg";
export { ForwardRef as ReactComponent };